export const fmtPrice = (v, currency = "USD") => {
  if (v == null) return "—";
  if (currency === "GBp")
    return `${v.toLocaleString(undefined, { maximumFractionDigits: 1 })}p`;
  const sym = currency === "GBP" ? "£" : currency === "EUR" ? "€" : "$";
  return `${sym}${v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const fmtCap = (v, currency = "USD") => {
  if (!v) return "—";
  const sym = currency === "GBp" || currency === "GBP" ? "£" : "$";
  if (v >= 1e12) return `${sym}${(v / 1e12).toFixed(2)}T`;
  if (v >= 1e9) return `${sym}${(v / 1e9).toFixed(1)}B`;
  return `${sym}${(v / 1e6).toFixed(0)}M`;
};

export const fmtNum = (v, d = 2) =>
  v == null ? "—" : v.toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });

export const fmtPct = (v, d = 2) => (v == null ? "—" : `${v > 0 ? "+" : ""}${v.toFixed(d)}%`);

export const changeClass = (v) =>
  v == null ? "text-muted-foreground" : v >= 0 ? "text-gain" : "text-loss";

export const trendBadgeClass = (trend) =>
  trend === "uptrend"
    ? "bg-gain/10 text-gain border-gain/30"
    : trend === "downtrend"
    ? "bg-loss/10 text-loss border-loss/30"
    : "bg-yellow-500/10 text-yellow-500 border-yellow-500/30";
